<template>
  <img
    v-if="matchLabelIcon"
    class="match-label-icon tw-flex-none"
    :src="matchLabelIcon"
    alt=""
  />
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useMatchLabelsStore, getLabelIcon } from '@ms/stores/matchLabels'

export default {
  name: 'IconMatchLabels',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    // 取值参数，参考 getLabelIcon 方法
    options: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const matchLabelIcon = ref(props.imgUrl)
    const matchLabelsStore = useMatchLabelsStore()
    const { matchLabels } = storeToRefs(matchLabelsStore)
    if (!props.imgUrl) {
      matchLabelIcon.value = getLabelIcon(props.options)
      if (!matchLabels.value.length) {
        const unwatch = watch(matchLabels, () => {
          matchLabelIcon.value = getLabelIcon(props.options)
          unwatch()
        })
      }
    }
    return { matchLabelIcon }
  }
}
</script>
